import { ResourceType } from '../../shared/resource-type';

/**
 * The resource type for License
 *
 * Needs to be in a separate file to prevent circular
 * dependencies in webpack.
 */
export const STATISTICS_CATEGORY = new ResourceType('category');
